/**
 * Checks whether the user has the required permission.
 * Used by the route guard and navigation filter to keep permission checks consistent.
 */
export function hasPermission(
  granted: string[] | null | undefined,
  required: string | null | undefined
): boolean {
  return !!required && !!granted?.includes(required);
}